import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';
import moment from 'moment';
import "./Logger.scss";
import RefreshButton from '../jobs/RefreshButton.react';
import Convert from 'ansi-to-html';
import SafeHTML from '../fw/SafeHTML.react';
import { Logger } from '../../common/types/types';

const regex = /^[[:blank:]]*([0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2})[[:blank:]]+(.*)/mg;

export function escapeXML(str) {
	if (str === undefined) {
		return '';
	}
	return String(str).replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;');
}

interface LoggerViewProps {
    intl: IntlShape;
    logger: Logger;
    relay: object;
}

class LoggerView extends React.Component<LoggerViewProps> {

    typeName = 'loggers';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        logger: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
    };

    render() {
        let { logger } = this.props;
        let convert = new Convert();

        let result = [];
        let idx = 0;
        for (let log of logger.edges) {
            if (log.node) {
                let title = null;
                let style = {};

                for (let row of log.node.message.split("\n")) {
                    let prefix = "";
                    for (let i = 0; i < row.length; i++) {
                        if (row.charCodeAt(i) === ' '.charCodeAt(0)) {
                            prefix += "&nbsp;";
                        } else {
                            break;
                        }
                    }

                    let m = regex.exec(row.trim());
                    if (m) {
                        let type = m[2];
                        let dt = m[1];
                        row = m[3];
                        if (type === "ERROR" || type === 'error') {
                            style['color'] = '#faa';
                        } else if (type === "DEBUG" || type === 'debug') {
                            style['color'] = '#afa';
                        } else if (type === "WARN" || type === 'warn') {
                            style['color'] = '#ffa';
                        }

                        title = moment(dt).format("DD.MM.YYYY HH:mm:ss") + " <" + type + ">";
                    }

                    row = escapeXML(row);
                    result.push(<div key={idx++} style={style}><SafeHTML title={title} value={convert.toHtml(prefix + row, {newline: true, escapeXML: true})} /></div>);
                }
            }
        }

        if (result.length === 0) {
            result = <div style={{'color': '#fff', 'textAlign': 'center', 'marginTop': '3em'}}><strong><FormattedMessage defaultMessage="No logs ..." id="logger.empty" /></strong></div>;
        }

        return (
            <div className="logger">
                <RefreshButton className="btn-sm" fastRefresh relay={this.props.relay} />
                <div className="loggerScrollable">
                    <div className="loggerContent">
                        {result}
                    </div>
                </div>
            </div>
        );
    }
}

export default Relay.createContainer(injectIntl(LoggerView), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        logger: () => Relay.QL`
            fragment on loggersConnection {
                edges {
                    node {
                        id,
                        realId,
                        message,
                        createdAt,
                    }
                }
            }
        `,
    },
});
